import { List } from "immutable";

import { Dispatch } from "common/types";

import {
  applyCompleteSessionEventToUserStat,
  receiveReconciledUserStudyStats,
  transformServerUserStat,
  UserStatServerType
} from "seneca-common/features/stats/state";

import SessionReport from "../../models/SessionReport";

export const reconcileUserStats = async (
  sessionReports: List<SessionReport>,
  userStatsFetch: Promise<UserStatServerType | null | undefined>,
  dispatch: Dispatch
) => {
  const userStatsFromServer = await userStatsFetch;

  if (userStatsFromServer && !(userStatsFromServer instanceof Error)) {
    const transformedUserStats = transformServerUserStat(userStatsFromServer);
    const userStatsWithSessionEventsApplied = sessionReports
      .map(report => report.session)
      .reduce(
        (userStats, sessionEvent) =>
          applyCompleteSessionEventToUserStat(userStats, sessionEvent!),
        transformedUserStats
      );
    dispatch(
      receiveReconciledUserStudyStats(userStatsWithSessionEventsApplied)
    );
  }
};
